module.exports = __webpack_public_path__ + "static/media/add attendance.6a31d132.svg";